module.exports = __webpack_public_path__ + "img/ennetix-individual-network-elements-page5.acc3a6e9.png";